var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcInvoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2",
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#003c8f",
    d: "M27,29H9a1,1,0,0,1-1-1V16a1,1,0,0,1,2,0V27H26V6a1,1,0,0,0-1-1H7A1,1,0,0,1,7,3H25a3,3,0,0,1,3,3V28A1,1,0,0,1,27,29Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003c8f",
    d: "M9,17H5a1,1,0,0,1-1-1V6a3,3,0,0,1,6,0V16A1,1,0,0,1,9,17ZM6,15H8V6A1,1,0,0,0,6,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003c8f",
    d: "M19,19H13a1,1,0,0,1,0-2h6a1,1,0,0,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003c8f",
    d: "M23,23H13a1,1,0,0,1,0-2H23a1,1,0,0,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003c8f",
    d: "M21,15H13a1,1,0,0,1,0-2h8a1,1,0,0,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003c8f",
    d: "M23,8H13a1,1,0,0,1-1-1V4a1,1,0,0,1,1-1H23a1,1,0,0,1,1,1V7A1,1,0,0,1,23,8ZM14,6h8V5H14Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "frame"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 32,
    width: 32
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInvoice);
export default __webpack_public_path__ + "static/media/ic_invoice.02a161b29bafc77b38827720ba80a523.svg";
export { ForwardRef as ReactComponent };